/**
 * Home — what the Home tab opens. The vibes, drawn like in the creator, one tap
 * from starting a puzzle, with the app's header and nav around them.
 *
 * Tapping a vibe opens the creator with it already chosen: the creator starts on
 * "who is it for?" and goes straight to the first clue after it. A Pro vibe on a
 * Free account goes to the paywall instead, like everywhere else.
 */
import { useTranslation } from "react-i18next";
import { orderedThemesFor } from "../themes/orderedThemes";
import { VibeCard } from "../creator/screens/StartScreens";
import { Heading, Sub } from "../creator/chassis/widgets";
import { C, FONT } from "../creator/chassis/tokens";

export default function HomeScreen({ themes, isPro, onPick, onLocked, now = new Date(), allSeasons = false }) {
  const { t: tr } = useTranslation();
  const entries = orderedThemesFor(themes, now, { allSeasons });
  return (
    <div data-testid="home-screen" style={{ maxWidth: 480, margin: "0 auto", padding: "8px 20px 28px", boxSizing: "border-box", fontFamily: FONT, color: C.ink }}>
      <div style={{ padding: "0 4px" }}>
        <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: "0.14em", textTransform: "uppercase", color: C.accent }}>
          {tr("app.creator.name.eyebrow")}
        </div>
        <Heading size={36} accent={tr("app.home.headingAccent")}>{tr("app.home.heading")}</Heading>
        <Sub>{tr("app.home.sub")}</Sub>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 14, margin: "22px 0 8px" }}>
        {entries.map(({ key, until }, i) => {
          const locked = themes[key].locked === true && !isPro;
          return (
            <VibeCard
              key={key}
              themeKey={key}
              until={until}
              testId={`home-vibe-${key}`}
              label={tr(`app.themes.${key}.name`, { defaultValue: themes[key].name })}
              tagline={tr(`app.themes.${key}.description`, { defaultValue: themes[key].description })}
              selected={false}
              locked={locked}
              tilt={i % 2 === 0 ? -1.2 : 1.1}
              onSelect={() => (locked ? onLocked(key) : onPick(key))}
            />
          );
        })}
      </div>

    </div>
  );
}
